import { useAuth } from "@/lib/auth";
import { cashScopeKey } from "@/hooks/use-branch-cash";

/** Cache partitioning only; authorization remains the API's responsibility. */
export function useStaffScope() {
  const {currentWorkspace,user,roles}=useAuth();
  return {currentWorkspace,user,scope:cashScopeKey(currentWorkspace?.id,user,roles?.find(role=>role.id===user?.roleId)?.permissions.map(permission=>permission.id))};
}
